const axios = require("axios").default;

const URL = `${process.env.REACT_APP_API_URL}/return/myapproval`;
const URL_APPROVAL = `${process.env.REACT_APP_API_URL}/return/approval`;
const URL_EDIT = `${process.env.REACT_APP_API_URL}/return/detail`;

export const getAll = (payload) => {
  return axios.get(URL, {
    params: payload,
  });
};

export const postApproval = (payload) => {
  return axios.post(URL_APPROVAL, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const editApproval = (id, params) => {
  console.log(id, "id 2");
  console.log(params, "params 2");
  return axios.put(`${URL_EDIT}/${id}`, params).catch((error) => {
    if (error.response) {
      return error.response.data;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
